import { Link } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import Image from "../../assets/image";
import Functions from "./index,function";
export default function SidenavbarCom() {
  const {
    setIsOpen,
    isOpen,
    menuItems,
    navigate,
    setHoveredItem,
    isActive,
    hoveredItem,
  } = Functions();
  return (
    <div className="relative">
      <button
        className="sm:hidden fixed top-0 left-1 xs:top-2 z-50 group bg-goldMetallic xs:text-sm xs:w-5 xs:h-5 rounded-full text-primary flex justify-center items-center transform transition-transform duration-300 hover:scale-110"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? (
          <IoClose className="transform transition-transform duration-300 group-hover:rotate-180" />
        ) : (
          <RxHamburgerMenu className="transform transition-transform duration-300 group-hover:rotate-180" />
        )}
      </button>
      <div
        className={`bg-[#000000] fixed sm:left-3 xs:top-0 xs:w-40 sm:top-16 scroll-container xs:h-screen sm:h-[calc(100vh-4rem)] z-40 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out sm:translate-x-0 sm:static flex flex-col`}
      >
        <div className="xs:block sm:hidden xs:py-1.5 xs:pl-7">
          <Link to={"/"}>
            <img className="w-10 h-10" src={Image.newlogo} alt="Logo" />
          </Link>
        </div>
        <div className="bg-[#121212] relative flex-1 scroll-container rounded-t-xl sm:mt-1.5">
          <div className="xs:pl-1 sm:pl-2 xl:pl-3">
            <ul>
              {menuItems.map((item) => (
                <li
                  key={item.id}
                  onClick={() => navigate(item.path)}
                  onMouseEnter={() => setHoveredItem(item.id)}
                  onMouseLeave={() => setHoveredItem(null)}
                  className={`flex items-center relative xs:gap-2 sm:gap-3 xl:gap-5 cursor-pointer xs:my-1 xs:pl-2 xs:py-1.5 sm:my-2.5 sm:pl-3 sm:py-1.5 lg:my-5 lg:py-2 xl:pl-5 
                                        ${
                                          isActive(item.path)
                                            ? "bg-[#262626]"
                                            : "hover:bg-[#262626]"
                                        } xs:rounded-s-sm sm:rounded-s-[4px] lg:rounded-s-lg`}
                >
                  <img
                    src={
                      hoveredItem === item.id
                        ? item.activeIcon
                        : isActive(item.path)
                        ? item.activeIcon
                        : item.icon
                    }
                    alt={item.label}
                    className="xs:w-3 sm:w-3.5 lg:w-5"
                  />
                  <span className="font-onestRegular text-secondary xs:text-xs sm:text-sm lg:text-base">
                    {item.label}
                  </span>
                  <span
                    className={`font-onestRegular absolute xs:right-8 right-5 top-1/2 -translate-y-1/2  xs:text-[6px] xs:leading-3 sm:text-[8px] lg:text-[10px] flex justify-center items-center xs:w-3.5 xs:h-3.5 sm:w-4 sm:h-4 lg:w-5 lg:h-5  rounded-full text-[#000000]`}
                    style={{ backgroundColor: item?.notificationbgColor }}
                  >
                    {item.notification}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="bg-[#121212] w-full rounded-b-xl overflow-hidden xs:!mb-[3px] sm:mb-1 sm:pt-1">
          {/* <div className="xs:pl-1 sm:pl-2 xl:pl-3">
                        <p className="font-onestRegular text-goldMetallic xs:text-[10px] sm:text-xs xs:mb-1 sm:mb-2 lg:mb-2.5">Cookies</p>
                        <div className="gap-2 flex items-center justify-start">
                            <p className="font-onestRegular text-secondary underline xs:text-[10px] sm:text-xs">Privacy Policy</p>
                            <p className="font-onestRegular text-secondary underline xs:text-[10px] sm:text-xs">Legal</p>
                            <p className="font-onestRegular text-secondary xs:text-[10px] sm:text-xs">Help</p>
                        </div>
                    </div> */}
          <div className="xs:pl-1 sm:pl-2 xl:pl-3 bg-[#262626]">
            <div className="group flex items-center xs:gap-2 sm:gap-3 lg:gap-5 xs:mt-2.5 xs:pl-2 xs:py-2.5 sm:mt-2.5 sm:pl-3 sm:py-3 lg:mt-5 lg:py-4 lg:pl-5">
              {/* <img
                                src={hoversettings ? Icons.settingActiveIcon : Icons.settingIcon}
                                alt="settingIcon"
                                className="xs:w-3 sm:w-3.5 lg:w-5 transition-transform duration-300 group-hover:rotate-90"
                            />
                            <span
                                className="font-onestRegular text-secondary cursor-pointer xs:text-xs sm:text-sm lg:text-base"
                                onMouseEnter={() => setHoversettings(true)}
                                onMouseLeave={() => setHoversettings(false)}
                            >
                                Settings
                            </span> */}
            </div>
          </div>
        </div>
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 sm:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </div>
  );
}
